/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /press_release/{release_id}/history/{release_history_id}
 * @export
 * @interface PostPressReleaseHistoryToUserHistorySuccessResponse
 */
export interface PostPressReleaseHistoryToUserHistorySuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseHistoryToUserHistorySuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostPressReleaseHistoryToUserHistorySuccessResponse
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseHistoryToUserHistorySuccessResponse
     */
    releaseId: number;
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseHistoryToUserHistorySuccessResponse
     */
    releaseHistoryId: number;
}

export function PostPressReleaseHistoryToUserHistorySuccessResponseFromJSON(json: any): PostPressReleaseHistoryToUserHistorySuccessResponse {
    return PostPressReleaseHistoryToUserHistorySuccessResponseFromJSONTyped(json, false);
}

export function PostPressReleaseHistoryToUserHistorySuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseHistoryToUserHistorySuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'releaseId': json['release_id'],
        'releaseHistoryId': json['release_history_id'],
    };
}

export function PostPressReleaseHistoryToUserHistorySuccessResponseToJSON(value?: PostPressReleaseHistoryToUserHistorySuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'release_id': value.releaseId,
        'release_history_id': value.releaseHistoryId,
    };
}

